//en.js

import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  head: {
    img: require('../../assets/img/fuzhou.jpg')
  },
  nav: {
    welcome1: 'International Conference on',
    welcome2: 'Cognitive Systems and Information Processing',
    date: 'December 25-27, 2020',
    address: 'Hengqin, Zhuhai, China',
    'tit-home': 'HOME',
    titOrganization: 'ORGANIZATION',
    titCommittee: 'COMMITTEES',
    titSubmissions: 'SUBMISSIONS',
    titProgram: 'PROGRAM',
    titRegistration: 'REGISTRATION',
    titTravel: 'TRAVEL',
    titContact: 'CONTACT',
    titPlaceholder: 'make you choices',
    register: 'INTENTION'
  },
  footer: {
    copyright: 'Copyright © ICCSIP 2022. All Rights Reserved.',
    message1:'NOTICE',
    message2:'Due to the epidemic situation, the meeting will be postponed to November. The review results will be fed back by email before September 26',
    message3:'Close'
  },
  home: {
    title: 'Welcome to ICCSIP 2022',
    content1:
      'The International Conference on Cognitive Systems and Information Processing (ICCSIP) will be held online during December 17-18, 2022. This conference aims to bring together nearly ten academicians in the field of artificial intelligence, nearly fifty top artificial intelligence experts and scholars from all over the world, nearly one hundred artificial intelligence entrepreneurs, and dozens of investors. Discuss the latest progress in the fields of artificial intelligence systems, cognitive systems and intelligent information processing, show new research results and future development prospects, and conduct discussions and exchanges around the industrial implementation of artificial intelligence technology.',
    content2:' The conference is hosted by Chinese Association for Artificial Intelligence, Chinese Association of Automation, and the IEEE Computational Intelligence Society; organized by Cogntive Systems and information Processing Society of Chinese Association for Artificial Intelligence, Cognitive Computing and Systems Society of Chinese Association of Automation, Fuzhou University.',
    // content12:'',
    // content13:'',
    //   ' This conference is sponsored by Cognitive Systems and Information Processing Society of Chinese Association for Artificial Intelligence, Cognitive Computing and Systems Society of Chinese Association of Automation, Intelligent Robot Society of China Computer Federation, Tsinghua University, Science in China Press, and technically sponsored by IEEE Computational Intelligence Society, Science in China Series F: Information Sciences, IET Cognitive Computation and Systems and the National Natural Science Foundation Committee.',

      // "title2": 'Important Dates',
    // "date1": ' July/1/2021"',
    // "desc1": 'Paper Submission Deadline',
    // "date2": ' August/1/2021"',
    // "desc2": 'Notification of Acceptance',
    // "date3": 'August/21/2021"',
    // "desc3": 'Author Registration',
    title1:
      'Seventh International Conference on Cognitive Systems and Information Processing',
    title11:'December 17-18, China',
    content3: 'Hosts: Chinese Association for Artificial Intelligence, Chinese Association of Automation, IEEE Computational Intelligence Society',
    content4:
      'Organizers: Cogntive Systems and information Processing Society of Chinese Association for Artificial Intelligence, Cognitive Computing and Systems Society of Chinese Association of Automation, Fuzhou University',
    content5:
      'Co-organizers: Coming soon ...'
    ,content6:'Supporter: Coming soon ...'
    },
  submissions: {
    title1: 'Call for Papers and Special Sessions',
    content1:
      'Original papers are invited from multidisciplinary perspectives on subject areas including, but not limited toapers are invited from multidisciplinary perspectives on subject areas including, but not limited to.',
    content2:
      'In addition, ICCSIP 2022 Program Committees solicit proposals for special sessions within the technical scopes of the conference. Special sessions, to be organized by internationally recognized experts, aim to bring together researchers in special focused topics. Papers submitted for special sessions are to be peer-reviewed with the same criteria used for the contributed papers. Researchers interested in organizing special sessions are invited to submit formal proposals to ICCSIP 2022. A special session proposal should include the session title, a brief description of the scope and motivation, names, contact information and brief biographical information on the organizers',
    content3: 'Template of papers: ',
    content4: 'Microsoft Word',
    content5: 'LaTeX',
    'tit-cog': 'Cognitive Systems',
    'tit-info': 'Information Processing',
    papers: [
      {
        cog: 'Cognitive sciences and technology',
        info: 'Information presentation and metrics'
      },
      {
        cog: 'Visual cognition and computation',
        info: 'Multi-modal information interaction and fusion '
      },
      {
        cog: 'Auditory cognitive processing',
        info: 'Big data and intelligent information processing'
      },
      {
        cog: 'Innovative cognitive computing model',
        info: 'Neural cognitive computation and learning'
      },
      {
        cog: 'Cognitive metrics',
        info: 'Visual information processing'
      },
      {
        cog: ' Tactile cognition and computation',
        info: 'Tactile information processing'
      },
      {
        cog: 'Cognitive psychology',
        info: 'Brain-computer interface'
      },
      {
        cog: 'Cognitive robotics',
        info: 'Bioinformatics and applications'
      },
      {
        cog: 'Cognitive radio',
        info: 'Multi-modal cognitive mechanism for dexterous operation'
      },
      {
        cog: 'Cognitive radars',
        info: 'Extreme learning /other learning machines and applications '
      }
    ],
    title2: ' Paper Submission',
    content6: 'Submit at: ',
    submit2: 'Coming soon ...',
    content7: "If you don't have an easychair account, please sign up first at:",
    signupat: 'Coming soon ...',
    content8:
      'Authors are invited to submit full-length papers (12 pages minimum) by the submission deadline through the online submission system. Potential organizers are also invited to enlist five or more papers with cohesive topics to form special sessions. The submitted paper implies that it is original and has not been submitted under review or is not copyright-protected elsewhere and will be presented by an author if accepted. All submitted papers will be refereed by experts in the field based on the criteria of originality, significance, quality, and clarity. The authors of accepted papers will have an opportunity to revise their papers and take consideration of the referees comments and suggestions. Papers presented at ICCSIP 2022 will be published in the EI-indexed proceedings and some selected top papers will be included in special issues of several SCI-indexed journals',
    content9:
      "The submitted paper implies that it is original and has not been submitted under review or is not copyright-protected elsewhere and will be presented by an author if accepted. All submitted papers will be refereed by experts in the field based on the criteria of originality, significance, quality, and clarity. The authors of accepted papers will have an opportunity to revise their papers and take consideration of the referees' comments and suggestions.",
    content10:
      'Papers presented at ICCSIP 2022 will be published in the EI-indexed proceedings and some selected top papers will be included in special issues of several SCI-indexed journals.',
    'journal-title': 'Journals',
    journals: [
      'Cognitive Computation and Systems',
      'International Journal of Control, Automation, and Systems',
      'Robotics and Autonomous Systems',
      'Science China: Information Sciences',
      'Tsinghua Science and Technology (English Version)',
      'IEEE Transactions on Cognitive and Development Systems',
      'IEEE Transactions on Fuzzy Systems'
    ],
    dates: [
      {
        process: 'Paper submission deadline',
        date: 'Oct. 10, 2022'
      },
      {
        process: 'Acceptance notification date',
        date: ' Oct. 30, 2022'
      },
      {
        process: 'Camera-ready copy and author registration',
        date: 'Nov. 10, 2022'
      }
    ],
    title3: 'Important Dates'
  },
  organization: {
    title1: 'Fuzhou University',
    title1description1: 'Founded in 1958, Fuzhou University is one of the national key universities that are selected into the “211 Project”, a Chinese government programme for the 21st century to support 100 selected universities for their further rapid development. Since its establishment, Fuzhou University has developed into a key comprehensive university in Fujian Province, giving priority to engineering courses and also enjoying a reputation for excellence in other fields including sciences, economics, management, liberal arts, law, arts and design, etc.',
    title1description2: 'Now Fuzhou University covers more than 333 hectares, including several campuses such as Yishan campus, Qishan campus, Tongpan campus and the School of Art and Design in Xiamen. The main running campus is located in Qishan campus of the University Town of Fuzhou Region. There are 19 schools in Fuzhou University mainly for undergraduate education and two independently operated colleges -- Zhicheng College and Yangguang College. There are 4 post-doctoral research stations, 9 doctoral degree programmes for the first-rank disciplines, 54 doctoral degree programmes for the second-rank disciplines, 29 master’s degree programmes for the first-rank disciplines and 168 master’s degree programmes for the second-rank disciplines and 11 professional degree authorization stations.',
    title1description3: 'Fuzhou University has been approved by the Ministry of Education to offer undergraduate and postgraduate programmes to students from Hong Kong, Macao, Taiwan regions and foreign countries. At present, there are about 50,000 students in Fuzhou University, including about over 5,200 doctoral and master’s degree seekers. Since its establishment, about 200,000 students graduated from Fuzhou University, including full-time doctoral and master’s degree students as well as those with the bachelor’s degrees and associate degrees.',
    title1description4: 'Fuzhou University has been taking great efforts to develop the cooperation and exchange. The international and national academic conferences have been conducted successfully in Fuzhou University so that the social academic influence from Fuzhou University has been enhanced. Academic exchanges on science, teaching and culture with Taiwan, Hong Kong and Macao regions have been actively carried out. The University is also positively engaged in promoting the exchanges between Chinese civilization and western civilization. “Library of the Western Belvedere”, the first western works center in China, and Institute of International Sinology have been established. The favorable collaborative relationship has been established with more than 20 universities in different countries, such as the United States, the United Kingdom, Germany, France, Russia, Japan, South Korea and so on. Fuzhou University has become an important window of scientific, academic, educational and cultural exchanges in Fujian Province.',
    title1description5: '',
    title1description6: '',
    title1description7: '',
    title1description8: '',
    title1description9: '',
    title1description10: '',
    // title1: 'Coming soon ...',
    // type1: 'Host',
    type1: 'Coming soon ...',
    name1: 'Chinese Association for Artificial Intelligence',
    name2: 'Chinese Association of Automation',
    name3: 'IEEE Computational Intelligence Society',
    type2: 'Organizers',
    name30:' Cogntive Systems and information Processing Society of Chinese Association for Artificial Intelligence',
    name31:'Cognitive Computing and Systems Society of Chinese Association of Automation',
    name4:'Tsinghua University',
    name5: 'Gusu Laboratory of Material Science',
    type3: 'Co-organizer',
    name6: 'Nanjing Tsingzhan Institute of Artificial Intelligence',
    name7: 'China Center for Information Industry Development',
    name8: 'Artificial Intelligence and Sensing Technology Institute(SIP) Co.,Ltd.',
    type4:'Supporter',
    name9: 'NVIDIA-IM',
    title2: 'Organizing Committee',
    committee: {
      'Honorary Chairs': [
        {name:'Bo Zhang, China',img:require('../../assets/img/zhangbo.jpg'),position:"a Fellow of Chinese Academy of Sciences",position1:' the Director of Institute for Artificial Intelligence, Tsinghua University',position2:'the lifetime achievement award by China Computer Federation (CCF) in 2014',experience:""},
        {name:'Nanning Zheng, China',img:require('../../assets/img/组委会/郑南宁.jpg'),position:"a Fellow of Chinese Academy of Engineering",position1:"President of Chinese Association of Automation",position2:'IEEE Fellow',experience:""},
        {name:'Deyi Li, China',img:require('../../assets/img/组委会/李德毅.jpg'),position:"a Fellow of Chinese Academy of Engineering",position1:'honorary president of Chinese Association for Artificial Intelligence',experience:""},
      ],
      'Advisory Committee Chairs': [
        {name:'Qionghai Dai, China',img:require('../../assets/img/组委会/戴琼海.png'),position:"A Fellow of Chinese Academy of Engineering",position1:"President of Chinese Association for Artificial Intelligence",position2:'the Director of School of Information Scicnce and Technology, Tsinghua University',experience:""},
        {name:'Fuji Ren, China',img:require('../../assets/img/组委会/任继福.png'),position:"A Fellow of the Japanese Academy of Engineering",position1:'Professor of Tokushima University',position2:"Director of Affective Computing and Intelligent Robot Lab",experience:""},
        // {name:'Jianwei Zhang, Germany',img:require('../../assets/img/组委会/张建伟.jpg'),position:"Professor, Department of information science, University of Hamburg, Germany",position1:"Director, Institute of multimodal Technology",position2:"Academician General of Hamburg Academy of Sciences, Germany",experience:""},
        {name:'Shiming Hu, China',img:require('../../assets/img/组委会/胡世民.jpg'),position:"Professor of Tsinghua University",position1:'Academic leader of the National Natural Science Foundation of China Innovation Group Project',experience:""},
        // {name:'Hui Yang, China',img:require('../../assets/img/组委会/杨辉.jpg'),position:"Doctoral Supervisor",position1:'Winner of the National Science Fund for Distinguished Young Scholars',position2:'Executive General Director of Gusu Lab',experience:""},
      ],
      'General Chairs': [
        {name:'Fuchun Sun, China',img:require('../../assets/img/组委会/孙富春.jpg'),position:"Professor, doctoral supervisor, Tsinghua University",position1:'IEEE/CAAI/CAA Fellow',position2:'Winner of the National Science Fund for Distinguished Young Scholars',experience:"Winner of the National Science Fund for Distinguished Young Scholars;兼任清华大学校学术委员会委员，计算机科学与技术系学术委员会主任，智能技术与系统国家重点实验室常务副主任。兼任担任国家重点研发计划机器人总体专家组成员，中国人工智能学会副理事长，中国自动化学会和中国认知科学学会常务理事"},
        {name:'Angelo Cangosi, United Kindom',img:require('../../assets/img/组委会/Angelo.png'),position:"Professor of machine learning and robotics, University of Manchester, UK",position1:'Research Fellow, Allen Turing Institute',experience:"Angelo是英国普利茅斯大学（Plymouth University）机器人和神经系统中心（Centre for Robotics and Neural Systems）的人工智能和认知教授和创始主任。IEEE Transactions on Autonomous Development的主编。他的最新著作《发育机器人学。从婴儿到机器人》（麻省理工学院出版社；与马特-施莱辛格合著）于2015年1月出版，最近被翻译成中文和日文。"},
        {name:'Jianwei Zhang, Germany',img:require('../../assets/img/组委会/张建伟.jpg'),position:"Professor, Department of information science, University of Hamburg, Germany",position1:"Director, Institute of multimodal Technology",position2:"Academician General of Hamburg Academy of Sciences, Germany",experience:""},
        {name:'Guolong Chen, China',img:require('../../assets/img/组委会/陈国龙.jpg'),position:"Professor, College of Computer and Data Science, Fuzhou University",position1:"Vice President of Fujian Association for Artificial Intelligence",position2:'',experience:""},
      ],
      // 'Regional Chair': [
      //   {name:'Jonathan Garibaldi, United Kindom', position:""},
      //   {name:'Katharina Rohlfing, Germany', position:""},
      // ],
      'Program Committee Chair':[
        {name:'Dewen Hu,China',position:"National University of Defense Technology"},
        {name:'Wenzhong Guo, China', position:"Fuzhou University"},
        {name:'Stefan Wermter, Germany',position:"University of Hamburg"},
        // {name:'Xin Yao, United Kindom',position:""},
        // {name:'Lei Yang, China',position:"Tsingzhan Artificial Intelligence Research Institute"},
        {name:'Huaping Liu, China',position:"Associate professor of Tsinghua University, doctoral supervisor, winner of National Outstanding Youth Fund"},
      ],
      // 'Regional Program Committee Chair':[
      //   {name:"Huaping Liu, China",position:"Tsinghua University"},
      //   {name:"Antonio Chella, Italy",position:""},
      //   {name:'Guang-Bin Huang,  Singapore',position:"Nanyang Technological University"},
      //   {name:"Chenguang Yang, United Kindom",position:""},
      // ],
      'Publication Chair':[
        {name:"Bin Fang, China",position:"Tsinghua University"},
        // {name:"Feng Chang, China",position:"Gaitech"},
        // {name:"Cheng Fang, Denmark",position:"University of Southern Denmark"},
        // {name:"YuShu Yu, China",position:"Beijing Institute Of Technology"},
        // {name:"Yong Cao, China",position:"Northwestern Polytechnical University"},
        // {name:"Mingjie Dong, China",position:"Beijing University Of Technology"},
      ],
      // 'Program Committee':[
      //   {name:'Chenguang Yang,  UK',position:"University of the West of England"},
      //   {name:'Guang-Bin Huang,  Singapore',position:"Nanyang Technological University"},
      //   {name:'Katharina Rohlfing,  Germany',position:"University of Padeborn"},
      //   {name:'Antonio Chella,  Italy',position:"Università degli Studi di Palermo"},
      //       {name:'Yufei Hao,  Switzerland',position:"EPFL"},
      //
      //   // {name:"Bin Fang, China",position:"Tsinghua University"},
      //   // {name:'Antonio Chella, Italy',position:"Università degli Studi di Palermo"},
      //   // {name:"Weiwei Wang, Japan",position:"Osaka University"},
      //   // {name:"Shaolong Kuang, China",position:"Shenzhen Technology University"},
      //   // {name:"Haiyuan Li, China",position:"Beijing University of Posts and Telecommunications"},
      // ],
      // 'Local Organization Chair':[
      //   {name:"Yuanlong Yu, China",position:"Fuzhou University"},
      //   {name:"Qinghai Zheng, China",position:"Fuzhou University"},
      //   {name:"Zhen Deng, China",position:"Fuzhou University"},
      // ],

      // 'Plenary Sessions Chairs': ['Zengguang Hou, China', 'Chenglin Wen, China '],
      // 'Special Sessions Chairs': ['Fei Song, China', 'Yixu Song, China', 'Zhijie Xia, China'],
      // 'Publications Chairs': ['Wei Li, USA', 'Quanbo Ge, China'],
      // 'Publicity Chairs': ['Shuhui Fu, China', 'Guo Chen, China'],
      // 'Finance Chair': ['Pengfei Wang, China'],
      // 'Registration Chair': ['Jianqin Yin, China'],
      // 'Local Arrangements Chairs': ['Yiwei Dai, China', 'Zhongyi Chu, China', 'Changhe Chu, China'],
      // 'Electronic Review Chair': ['Xiaolin Hu, China']
    },
    committee2:{
      'Program Committee': [
        {name:'Chenguang Yang,  UK',position:"University of the West of England"},
        {name:'Guang-Bin Huang,  Singapore',position:"Nanyang Technological University"},
        {name:'Katharina Rohlfing,  Germany',position:"University of Padeborn"},
        {name:'Antonio Chella,  Italy',position:"Università degli Studi di Palermo"},
        {name:'Yufei Hao,  Switzerland',position:"EPFL"},
        {name:'Zhen Deng,  China',position:"Fuzhou university"},
        {name:'Jun Ren, China',position:"Hubei University of Technology"},
        {name:'Chunfang Liu,  China',position:"Beijing University of Technology"},
        {name:'Changsheng Li,  China',position:"Beijing Institute of Technology"},
        {name:'Mingjie Dong,  China',position:"Beihang University"},
        // {name:'Peng Su, China',position:"Beijing Information Science and Technology University"},
        {name:'Rui Huang,  China',position:"University of Electronic Science and Technology of China"},
        {name:'Tian Liu,  China',position:"Beijing Information Science and Technology University"},
        {name:'Haiyuan Li,  China',position:"Beijing University of Posts and Telecommunications"},
        {name:'Yong Cao, China',position:"Northwestern Polytechnical University"},
        {name:'Taogang Hou,  China',position:"Beijing Jiaotong University"},
    ],
    }

  },
  Program: {
    title: 'Program-at-a-Glance',
    // title: 'Coming soon ...',
    src1: require('../../assets/img/program1.png'),
    src2: require('../../assets/img/program2a.png'),
    src3: require('../../assets/img/program2b.png'),
    src4: require('../../assets/img/program3.png')
  },
  Registration: {
    // title: 'Registration (for Authors and Non-authors)',
    title: 'Coming soon ...',
    content1: 'Registration fee: RMB 2600',
    content2: 'RMB 2600',
    content3: '. The remittance shall be made to the following account. Adding remarks',
    content33:'',
    content333:'',
    content4: '"ICCSIP", author\'s name and Paper ID. ',
    content44:'Non-author must ',
    content444:'add remarks',
    content4444:'"ICCSIP", author\'s name and No paper',
    content5: '.',
    timestamp1: '1) Direct remittance',
    timestamp2: '2) Alipay transfer',
    organization: 'Organization: 中国人工智能学会',
    bank: 'Bank: 中国工商银行新街口支行',
    account: 'Account: 0200002909200166203',
    content6: 'Then please fill in the ',
    content7: 'registration form and consent to publication form ',
    content8: 'in the attached file and email to',
    content9: 'iccsip2022@163.com',
    content10: '',
    content11: 'Notice of the Chinese version: ',
    content12: 'ICCSIP2022会议通知'
  },
  Travel: {
    url:'https://bushantest.oss-cn-hangzhou.aliyuncs.com/en.pdf',
    title: 'History & Culture',
    content1:
      'As one of the first group of "Cultural and Historic Cities" of China as well as a key scenic tourist city, Suzhou has a history of over 2500 years since He Lv, the King of Wu State, established the city in 514 BC.',
    content11:'It is still on its original location during the Spring and Autumn Period, and preserves the double chessboard layout of "water and land in parallel,  canal and street in neighbor", the network of rivers and canals composing three vertical, three horizontal and one ring, and the unique landscape of "small bridges, flowing water, white walls, black tiles, cultural relics and classical gardens".',
    content12:'9 classical gardens of Suzhou and the Suzhou Section of the Grand Canal are listed in the Catalogue of World Cultural Heritage.',
    content13:'6 projects including Chinese Kunqu Opera and Chinese Guqin Art are listed in the Representative List of the Intangible Cultural Heritage of Humanity of the UN. ',
    content14:'As a cradle of generations of gifted people in history, Suzhou is home to numerous celebrities. There are altogether 51 civil and military No. 1 Scholars in history and 121 academicians of the Chinese Academy of Sciences and Chinese Academy of Engineering coming from Suzhou, and therefore Suzhou is known as a famous "Hometown of Scholars" and "Hometown of Academicians".',
    
    timeline1:
      'Portugal claimed both Xiao Hengqin and Da Hengqin, along with the larger former island of Wanzai — now a peninsula — to their north, as part of the Macau. Portugal briefly occupied them before World War II.',
    timeline2: 'The two islands, Xiao Hengqin and Da Hengqin, were reclaimed into one island, which is now Hengqin Island.',

    timeline3: 'The Chinese government resumed the exercise of sovereignty over Macau, and the ',
    timeline4: "Macau Special Administrative Region of the People's Republic of China",
    timeline5: 'was established.',

    timeline6: 'The government of Macau officially announced that the',
    timeline7: 'University of Macau',
    timeline8: 'would build its new campus on the island.',
    timeline9: 'The State Council of China approves the establishment of ',
    timeline10: 'Hengqin New Area',
    timeline11: '.',
    title2: 'Transportation and Tourism',
    desc1:
      'Hensgqin has formed a relatively complete land, sea and air transportation system. It is a 40-minute drive from Zhuhai Airport and a 10-minute drive from Macau Airport. It is also only a 50-minute drive from Zhuhai Port, a hub port in South China.',
    tip1: 'friendly reminder: ',
    tip11:'Suzhou has a subtropical climate, the local climate is mild and humid, and the four seasons are distinct. Therefore, with the change of seasons, Suzhou gardens are sometimes clustered with flowers, sometimes dense with green trees, and sometimes covered in silver, presenting visitors with a variety of beautiful scenery.', 
    tip12:'Tiger Hill is a must-visit place for tourists to Suzhou, and is a symbol of Suzhou "s historical and cultural city.', 
    tip13:'Suzhou’s accommodation conditions are better and facilities are complete, but tourists still need to book rooms in advance before departure.', 
    tip14:'It is recommended to avoid weekends and holidays when visiting Suzhou gardens or visiting ancient water towns. Only by avoiding the crowds can we truly appreciate the unique charm of this ancient city of Suzhou.', 
    tip15:'Suzhou "s attractions basically close before 17:30, please arrange your time reasonably.', 
    tip16:'Suzhou’s famous delicacies include Caizhizhai, Songhelou Restaurant, Hanshan Temple Vegetarian Restaurant, Su-style noodles, etc., which can be tasted during the tour.', 
    tip17:'Su embroidery is one of Suzhou "s most famous tourist souvenirs, and Suzhou Biluochun tea is one of the top ten famous teas in China.', 
    tipMore:'For more travel guides, please click here',
    tip2: 'By Sea: ',
    tip3: 'By Land: ',
    desc2:
      'There are 5 international and domestic airports around Hengqin: Hong Kong International Airport, Macau International Airport, Guangzhou International Airport, Shenzhen International Airport, and Zhuhai Airport.',
    desc3:
      'There are 3 large ports around Hengqin: Wan Chai Pier, Kyushu Port and Shenzhen Shekou Port. Hengqin Passenger Terminal has just opened.',
    desc4: 'From downtown Zhuhai, Hengqin can be reached by multiple highways and bus lines.',
    desc5:
      'Hengqin Island got its name because of its shape like Guqin. It has a natural landscape of ten steps and one waterfall and hundreds of steps and trees.',
    desc6:
      'The remains of the naval battles of the Song and Yuan armies in ancient times are still preserved, and there are also Tianhu Scenic Area, Triassic Spring, Ocean Paradise, Shibo Garden and other scenic spots.',
    desc7:
      'It is close to Macau and is a new city with a little landscape, suitable for entertainment and shopping. In addition, it is also a famous oyster eating spot in Zhuhai.'
  },
  Contact: {
    title1: 'Contact Us',
    // title1: 'Coming soon ...',
    
    contacts: [
      {
        active:"Notice of Artificial Intelligence and Cognitive Intelligence International Conference, please follow",
        item: 'Contacts',
        content: 'E-mail Address: iccsip2022@163.com',
        content11:'Leasing Manager: <br></br>Yuxin Chen <br></br>+86 13301585615  <br></br>xxxxxx@163.com',
        icon: 'el-icon-user',
        img:"https://bushantest.oss-cn-hangzhou.aliyuncs.com/tsingzhan.jpg",
        type: 'primary'
      },
      // {
      //   item: 'Email',
      //   content:'iccsip2021@163.com',
      //   content:'tsingzhan@163.com',
      //   icon: 'el-icon-message',
      //   type: 'danger'
      // },
      // {
      //   item: 'Phone',
      //   content: 'Qianyi Sun : +86 15952525480',
      //   content11:'Guo Chen : +86 18811742491',
      //   icon: 'el-icon-phone-outline',
      //   type: 'warning'
      // },
      // {
      //   item: 'WeChat Official Account',
      //   content: '认知系统与信息处理专委会',
      //   icon: 'el-icon-chat-round',
      //   type: 'success',
   
      // }
    ]
  },
  Reginst:{
    phone:"Phone",
    spectators:"Company",
    characters:'Identity',
    content:"Warm tips: All registered users are eligible to participate in the lucky draw. The prizes include iPad, Huawei mobile phone, Jetson nano development board, and the chance to visit Suzhou and Hangzhou for free.",
    checkphone:"Verification Code",
    type1:'Paper Author',
    type2:'Visitor',
    message11:'Register',
    message12:'Reset',
    companyMessage:'This cannot be empty',
    message13:'',
    typeMessage:'Choose your indentity',
    CodeMessage:'Sent',
    PhoneErr1:'Do not re-register',
    phoneErr2:'This cannot be empty',
    phoneErr3:'Wrong format',
},
  ...enLocale
}

export default en
